import React from "react";
import { TEAL } from "./constants";

const named = (el) => el.name || (el.type === "artboard" ? "Artboard" : null);

export default function ExportPanel({
  selected, scope, onScope, onExport, busy, onClose, error,
}) {
  const chosen = selected || [];
  const target = scope === "board" || chosen.length === 0
    ? "the whole board"
    : chosen.length === 1
      ? (named(chosen[0]) ? `“${named(chosen[0])}”` : "what you selected")
      : `${chosen.length} selected items`;

  const action = (id, label, hint) => (
    <button
      key={id}
      type="button"
      disabled={Boolean(busy)}
      onClick={() => onExport(id)}
      className="w-full text-left px-3 py-[9px] rounded-lg border cursor-pointer disabled:opacity-50 transition-colors hover:bg-slate-50"
      style={{ borderColor: "rgba(0,0,0,0.08)", background: "white" }}
    >
      <div className="text-[12px] font-semibold text-slate-700 leading-none">
        {busy === id ? "Working…" : label}
      </div>
      <div className="text-[10px] text-slate-400 pt-[3px] leading-none">{hint}</div>
    </button>
  );

  return (
    <div
      className="absolute right-3 top-3 z-[60] rounded-xl border border-black/[0.08] shadow-[0_10px_30px_rgba(0,0,0,0.18)] font-['DM_Sans']"
      style={{ background: "#FFFFFF", width: 260, display: "flex", flexDirection: "column" }}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onDoubleClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between px-3 py-2 border-b border-black/[0.06]">
        <div>
          <div className="text-[12px] font-bold text-slate-800 leading-none">Export</div>
          <div className="text-[10px] text-slate-400 pt-[3px] leading-none">Exporting {target}</div>
        </div>
        <button type="button" onClick={onClose} title="Close"
          className="text-slate-400 text-[16px] leading-none bg-transparent border-none cursor-pointer px-1">
          ✕
        </button>
      </div>

      {chosen.length > 0 && (
        <div className="flex gap-[4px] px-3 pt-2">
          {[["selection", "Selected"], ["board", "Whole board"]].map(([id, label]) => (
            <button
              key={id}
              type="button"
              onClick={() => onScope(id)}
              className="flex-1 text-[11px] font-semibold py-[5px] rounded-md cursor-pointer border"
              style={{
                color: scope === id ? TEAL : "#64748B",
                borderColor: scope === id ? "rgba(77,184,181,0.45)" : "rgba(0,0,0,0.10)",
                background: scope === id ? "rgba(77,184,181,0.12)" : "transparent",
              }}
            >
              {label}
            </button>
          ))}
        </div>
      )}

      <div className="flex flex-col gap-[6px] p-3">
        {action("png", "Download PNG", "An image file")}
        {action("pdf", "Download PDF", "A single page")}
        {action("desk", "Send to Desk", "Adds it to a document")}
        {action("bookshelf", "Send to Bookshelf", "Keeps it as a saved version")}
      </div>

      {error && (
        <p className="text-[11px] text-red-500 px-3 pb-3 m-0 leading-snug">{error}</p>
      )}
    </div>
  );
}
